// extracted by mini-css-extract-plugin
export default {"topNavigation":"_7iuph","container":"XZZw6","categoriesContainer":"u7SCd","link":"nzE9S","linkAccessibility":"sVvU2"};